import script from "./base-hour.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-hour.vue?vue&type=script&setup=true&lang=ts"

import "./base-hour.vue?vue&type=style&index=0&id=62319ce4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62319ce4"]])

export default __exports__